// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/.pnpm/css-loader@5.2.7_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "input[data-v-95cdc4d6]:-webkit-autofill,input[data-v-95cdc4d6]:-webkit-autofill:active,input[data-v-95cdc4d6]:-webkit-autofill:focus,input[data-v-95cdc4d6]:-webkit-autofill:hover,select[data-v-95cdc4d6]:-webkit-autofill{-webkit-box-shadow:inset 0 0 0 30px #fff;-webkit-text-fill-color:#677488}input[data-v-95cdc4d6]:-internal-autofill-selected{color:inherit}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
